var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlackBackButton = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.7957 19.2041C16.0071 19.4154 16.1258 19.7021 16.1258 20.001C16.1258 20.2999 16.0071 20.5865 15.7957 20.7978C15.5844 21.0092 15.2977 21.1279 14.9989 21.1279C14.7 21.1279 14.4133 21.0092 14.202 20.7978L6.70198 13.2978C6.5971 13.1933 6.51388 13.0691 6.4571 12.9324C6.40032 12.7956 6.37109 12.649 6.37109 12.501C6.37109 12.3529 6.40032 12.2063 6.4571 12.0696C6.51388 11.9328 6.5971 11.8086 6.70198 11.7041L14.202 4.2041C14.4133 3.99276 14.7 3.87402 14.9989 3.87402C15.2977 3.87402 15.5844 3.99276 15.7957 4.2041C16.0071 4.41544 16.1258 4.70209 16.1258 5.00097C16.1258 5.29986 16.0071 5.58651 15.7957 5.79785L9.09354 12.5L15.7957 19.2041Z",
  fill: "#1D1B20"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlackBackButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/black_back_button.fe5ae44412545742c0fde8900d985ebc.svg";